module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"changePlan":"Change plan","subject":"You are now switching to free plan “{nextPlan}”.","confirm":"Confirm"}}')
  delete Component.options._Ctor
}
